export { default } from 'experiments/deeplinks-flow-feature/treatment/features/store/pages/minimal-store-locator';
